import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
    form: {
        padding: theme.spacing(2)
    },
    fieldMargin: {
        marginBottom: theme.spacing(2)
    }
}))